import { AdUnit } from "../types/prebid";
import { SlotSizeConfig } from "../types/publisher";
import BaseBidder from "./BaseBidder";

export default class appnexus extends BaseBidder {

	protected get bidderName(): string {
		return 'appnexus';
	}

	protected get bidderSSP(): string {
		let suffix = '';
		if(this.bidderName != 'appnexus') {
			suffix = ' ' + this.bidderName;
		}
		return "Appnexus" + suffix;
	}

	protected additionalSlotSizes: SlotSizeConfig = {
		top: {
			desktop: [[970, 1000], [1800, 200], [1800, 500], [1800, 1000]],
			tablet:  [[1800, 200], [1800, 500]],
			mobile:  []
		}
	}

	protected adUnitConfig: AdUnit = {
		code: this.slot.path,

		ssp: this.bidderSSP,

		mediaTypes: {
			banner: {
				sizes: this.getAdUnitSizes()
			}
		},
		
		bids: [
			{ 
				bidder: this.bidderName, 
				params: {
					placementId: this.bidderConfig.toString()
				}
			}
		]
	}
}
